// extracted by mini-css-extract-plugin
module.exports = {"container":"Select-module--container--2YSQT","icon":"Select-module--icon--1w02Y","dropdown":"Select-module--dropdown--8QJ_t"};